import { ReactNode } from "react";
import { Stack, Box } from "@mui/material";

type Props = {
  children: ReactNode;
  /** @deprecated Prefer ListFilters for pages with many filters */
  variant?: "inline" | "grid";
};

const FiltersContainer = ({ children, variant = "inline" }: Props) => {
  if (variant === "grid") {
    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
          },
          gap: 1.5,
          width: "100%",
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Stack direction="row" gap={1.5} flexWrap="wrap" width="100%">
      {children}
    </Stack>
  );
};

export default FiltersContainer;
